import React, { Component } from "react";
import artificialintelligencebg11 from "../../images/artificialintelligencebg11.jpg";
import ReactHtmlParser from "html-react-parser";
import "./index.scss";
import ImageGroupComponent from "../../components/imageGroup/imageGroup";
import html1 from "./index.html";
import html2 from "./index2.html";
import html3 from "./index3.html";
import html4 from "./index4.html";
import html5 from "./index5.html";

class Latestdevelopments4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageGroup: [
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_1084_1780036904800_1780036904800_640_(2).jpg",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_553_1780036912264_1780036912264_640_(1).jpg",
      ],
      imageGroup2: [
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_417_1780037614308_1780037614308_640_(12).png",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_676_1780037680966_1780037680966_640_(11).png",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_307_1780037771333_1780037771333_640_(6).jpg",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_724_1780037786167_1780037786167_640_(5).jpg",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_418_1780037797318_1780037797318_640_(4).jpg",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_198_1780037687602_1780037687602_640_(10).png",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_969_1780037699430_1780037699430_640_(9).png",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_1030_1780037705185_1780037705185_640_(8).png",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_717_1780037711977_1780037711977_640_(7).png",
      ],
      imageGroup3: [
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_627_1780038291513_1780038291513_640_(16).png",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_475_1780038298644_1780038298644_640_(15).png",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_402_1780038307614_1780038307614_640_(10).jpg",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_606_1780038317062_1780038317062_640_(14).png",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_522_1780038326123_1780038326123_640_(9).jpg",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_187_1780038333298_1780038333298_640_(13).png",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_798_1780038276276_1780038276276_640_(11).jpg",
      ],
      imageGroup4: [
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_585_1780038543750_1780038543750_640_(22).png",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_205_1780038550852_1780038550852_640_(21).png",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_192_1780038557014_1780038557014_640_(20).png",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_268_1780038564688_1780038564688_640_(13).jpg",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_697_1780038571987_1780038571987_640_(12).jpg",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_699_1780038599693_1780038599693_640_(19).png",
        "https://cdn.umer.com.cn/umer-doctor/20260529/11002119_457_1780038610951_1780038610951_640_(18).png",
      ],
    };
  }
  render() {
    return (
      <div className="aboutussection">
        <img
          className="latestdeveimg2"
          src={artificialintelligencebg11}
          alt=""
        ></img>
        <div className="latestdevelopments_main" style={{ fontSize: 0 }}>
          {ReactHtmlParser(html1)}
          {/* {
            <ImageGroupComponent
              group={this.state.imageGroup}
            ></ImageGroupComponent>
          } */}
          {/* {<div style={{ width: "100%" }}>{ReactHtmlParser(html2)}</div>} */}
          {/* {
            <ImageGroupComponent
              group={this.state.imageGroup2}
            ></ImageGroupComponent>
          }
          {<div style={{ width: "100%" }}>{ReactHtmlParser(html3)}</div>}
          {
            <ImageGroupComponent
              group={this.state.imageGroup3}
            ></ImageGroupComponent>
          }
          {<div style={{ width: "100%" }}>{ReactHtmlParser(html4)}</div>}
          {
            <ImageGroupComponent
              group={this.state.imageGroup4}
            ></ImageGroupComponent>
          }
          {<div style={{ width: "100%" }}>{ReactHtmlParser(html5)}</div>} */}
        </div>
      </div>
    );
  }
}

export default Latestdevelopments4;
